import { ServiceGroup } from '@services';
import { useStore } from '@stores';
import { Form } from 'antd';
import React, { useCallback } from 'react';
import Presentation from './CreateServiceGroupForm.presentation';
interface IProps {
  onCancel: (value: boolean) => void;
  handleSelect?: (id: number) => void;
}

export const CreateServiceGroupForm: React.FC<IProps> = ({ onCancel, handleSelect }) => {
  const [form] = Form.useForm();
  const { serviceGroupStore } = useStore();

  const onFinish = useCallback(
    async (values: ServiceGroup) => {
      await serviceGroupStore.create({ ...values }).then((result) => {
        if (!result) return;
        form.resetFields();
        onCancel(false);
        handleSelect && handleSelect(result.id);
      });
    },
    [form, serviceGroupStore, onCancel, handleSelect]
  );

  return <Presentation form={form} onCancel={onCancel} onFinish={onFinish} />;
};
